import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../includes/myStyles.css";
import Upload_file from "./modal/Upload_file";
import { messages } from "../utility/services/message";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import NavBar_appID from "./layout/NavBar_appID";
import {
  getAppId,
  getEmail,
  set1BpersonalInfo,
  setAddressInfo,
  setDeclarationInfo,
  setEmergenceInfo,
  setParentInfo,
  setTravelInfo,
  setTStageID,
} from "../utility/Common";
import { createNotification } from "./Popup";
import { applicationManagementMasilingi } from "../utility/services/apiService";
import CentryReusableComponent from "./CentryReusableComponent";

const Step_six = () => {
  let navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const { checkApplicationStage } = CentryReusableComponent({});
  useState("");
  useEffect(() => {
    getAllAttachments();
  }, []);

  const finishUpload = async (e) => {
    setIsloading(true);
    const payload = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "FinishUpload",
      File: "",
      Type: "",
      DocTypeId: "",
    };

    try {
      const result = await applicationManagementMasilingi(
        payload,
        "add-attachment-info",
      );
      if (result.code == 1 && result.data) {
        if (result.data) {
          const stID = result?.data[0]?.StageID;
          setTStageID(stID);
        }
        goToDeclaration();
      } else if (
        result.code == 3 ||
        result.message?.toLowerCase().includes("expire")
      ) {
        createNotification({ type: "error", message: "Session expired" })();
        navigate("/");
      } else {
        const msg = result?.message || "Unexpected error occurred";
        createNotification({ type: "error", message: msg })();
      }
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        "Network Error. Please try again later.";
      createNotification({ type: "error", message: msg })();
    } finally {
      setIsloading(false);
    }
  };

  const goToDeclaration = async () => {
    setIsloading(true);
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Normal",
    };

    try {
      const result = await applicationManagementMasilingi(
        formData,
        "declaration",
      );
      if (result.code == 1 && result.data) {
        setDeclarationInfo(result.data);
        navigate("/stp7");
      } else if (
        result.code == 3 ||
        result.message?.toLowerCase().includes("expire")
      ) {
        createNotification({ type: "error", message: "Session expired" })();
        navigate("/");
      } else {
        const msg = result?.message || "Unexpected error occurred";
        createNotification({ type: "error", message: msg })();
      }
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        "Network Error. Please try again later.";
      createNotification({ type: "error", message: msg })();
    } finally {
      setIsloading(false);
    }
  };

  const getAllAttachments = async (e) => {
    checkApplicationStage(2);
    setIsloading(true);
    const payload = {
      DocTypeId: "",
      Type: "",
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "SelectAll",
    };

    try {
      const result = await applicationManagementMasilingi(
        payload,
        "add-attachment-info",
      );
      if (result.code == 1 && result.data) {
        checkIsMandatoryPass(result.data);
        setAttachments(result.data);
        checkIsMandatoryPass(result.data);
      } else if (
        result.code == 3 ||
        result.message?.toLowerCase().includes("expire")
      ) {
        createNotification({ type: "error", message: "Session expired" })();
        navigate("/");
      } else {
        const msg = result?.message || "Unexpected error occurred";
        createNotification({ type: "error", message: msg })();
      }
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        "Network Error. Please try again later.";
      createNotification({ type: "error", message: msg })();
    } finally {
      setIsloading(false);
    }
  };

  const handleUploadStatusChange = () => {
    getAllAttachments();
  };

  const checkIsMandatoryPass = (data) => {
    const newData = data.some(
      (item) => item.IsMandatory == true && item.AttachmentID == null,
    );
    setIsButtonDisabled(newData);
  };

  const endeleaBadae = () => {
    navigate("/");
  };

  //--------------------BackStage
  const handleBackStep = (endpoint, formData, routes) => {
    try {
      applicationManagementMasilingi(formData, endpoint).then((result) => {
        if (
          result.code == 3 ||
          result.message?.toLowerCase().includes("expire")
        ) {
          createNotification({ type: "error", message: "Session expired" })();
          navigate("/");
        } else if (result.code == 1 && result.data.length > 0) {
          if (endpoint == "add_missing_personal_info") {
            set1BpersonalInfo(result?.data[0]);
          } else if (endpoint == "add-address-info") {
            setAddressInfo(result.data[0]);
          } else if (endpoint == "add-parents-info") {
            setParentInfo(result.data[0]);
          } else if (endpoint == "add-travel-info") {
            setTravelInfo(result.data[0]);
          } else if (endpoint == "add-emergency-info") {
            setEmergenceInfo(result.data[0]);
          }
          const applicationFrom = result?.data[0]?.ApplicationFrom;
          const navigatePath = routes[applicationFrom] || routes.default;

          if (navigatePath) {
            navigate(navigatePath, { state: result?.data[0] });
          } else {
            const info = { type: "error", message: result.message };
            createNotification(info)();
          }
        } else {
          const info = { type: "error", message: result.message };
          createNotification(info)();
        }
      });
    } catch (error) {
      const info = { type: "error", message: messages.networkError };
      createNotification(info)();
    }
  };

  const backStp1 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      BirthVillage: "",
      BirthWardID: "",
      ZanzibarID: "",
      AnyOtherID: "",
    };
    const routes = {
      3: "/stp1B",
      4: "/stp1",
      default: null,
    };

    handleBackStep("add_missing_personal_info", formData, routes);
  };

  const backStp2 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      HouseNumber: "",
      ResidenceDistrictID: "",
      ResidenceVillage: "",
    };
    const routes = {
      default: "/stp2",
    };

    handleBackStep("add-address-info", formData, routes);
  };

  const backStp3 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      ResidenceDistrictID: "",
      ResidenceVillage: "",
      HouseNumber: "",
      FatherFullName: "",
      FatherDOB: "",
      FatherDistrictID: "",
      FatherWard: "",
      FatherVillage: "",
      MotherFullName: "",
      MotherDOB: "",
      MotherDistrictID: "",
      MotherWard: "",
      MotherVillage: "",
    };
    const routes = {
      default: "/stp3",
    };

    handleBackStep("add-parents-info", formData, routes);
  };

  const backStp4 = () => {
    const formData = {
      ApplicationId: getAppId(),
      TravellingPurposeID: "",
      CountryID: "",
      OccupationID: "",
      EmailAddress: getEmail(),
      Action: "Select",
      GuardianFullName: "",
      GuardianJob: "",
      GuardianBox: "",
      GuardianPhoneNumber: "",
      GuardianRelationShip: "",
    };
    const routes = {
      default: "/stp4",
    };

    handleBackStep("add-travel-info", formData, routes);
  };

  const backStp5 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      FirstContactName: "",
      FirstContactWorkID: "",
      FirstContactBox: "",
      FirstContactPhoneNo: "",
      FirstContactTown: "",
      FirstContactStreet: "",
      FirstContactHouseNumber: "",
      FirstContactRelationship: "",
      SecondContactName: "",
      SecondContactWorkID: "",
      SecondContactBox: "",
      SecondContactPhoneNo: "",
      SecondContactTown: "",
      SecondContactStreet: "",
      SecondContactHouseNo: "",
      SecondContactRelationship: "",
    };
    const routes = {
      default: "/stp5",
    };
    handleBackStep("add-emergency-info", formData, routes);
  };

  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp1();
                    }}
                    className="list-group-item done"
                  >
                    Habari Binafsi{" "}
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp2();
                    }}
                    className="list-group-item done"
                  >
                    Anuwani ya Makazi
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp3();
                    }}
                    className="list-group-item done"
                  >
                    Habari za Wazazi{" "}
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp4();
                    }}
                    className="list-group-item done"
                  >
                    Habari za Safari
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp5();
                    }}
                    className="list-group-item done"
                  >
                    Wakati wa Dharura
                  </Link>
                  <Link to="#" className="list-group-item active">
                    Viambatanisho{" "}
                  </Link>
                  <Link className="list-group-item ">Tamko Rasmi </Link>
                  <Link className="list-group-item ">Malipo </Link>
                </div>
              </div>
              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "1px" }}
              >
                <div className="tab-registration-content active">
                  <div className="box box-default">
                    <div className="box-header with-border">
                      <h3 className="box-title">Viambatanisho vya mwombaji</h3>
                    </div>
                    <br />
                    <table className="table table-striped custab">
                      <thead>
                        <tr>
                          <th></th>
                          <th style={{ width: "50%" }}>
                            Aina ya Kiambatanisho
                          </th>
                          <th style={{ width: "20%" }}>Hali</th>
                          <th style={{ width: "30%" }}>Hatua</th>
                        </tr>
                      </thead>
                      <tbody>
                        {attachments?.map((attachment, index) => (
                          <tr key={index}>
                            <td style={{ verticalAlign: "middle" }}>
                              {index + 1}.
                            </td>
                            <td style={{ verticalAlign: "middle" }}>
                              {attachment?.AttachmentName}{" "}
                              {attachment?.IsMandatory ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : (
                                <span style={{ color: "red" }}></span>
                              )}
                            </td>
                            <td style={{ verticalAlign: "middle" }}>
                              {attachment?.AttachmentID !== null ? (
                                <text className="text-success">Tayari</text>
                              ) : (
                                <text className="text-warning">Bado</text>
                              )}
                            </td>
                            <td>
                              <Upload_file
                                status={attachment}
                                refreshTable={handleUploadStatusChange}
                              />
                            </td>
                            <td></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="box-footer">
                    <div className="row">
                      <div className="col-md-4">
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            backStp5();
                          }}
                          className="btn btn-default btn-block btn-label-next"
                        >
                          <i className="fa fa-angle-double-left"></i> | Hatua
                          Iliyotangulia
                        </Link>
                      </div>
                      <div className="col-md-4">
                        <Link
                          className="btn btn-labeled btn-block btn-default"
                          name="SaveExit"
                          onClick={(e) => {
                            e.preventDefault();
                            endeleaBadae();
                          }}
                        >
                          Hifadhi na Toka | <i className="fa fa-save"></i>{" "}
                        </Link>
                      </div>
                      <div className="col-md-4">
                        <button
                          type="submit"
                          className="btn btn-default btn-block btn-label-next"
                          name="SaveNext"
                          value="SaveContinue"
                          onClick={finishUpload}
                          disabled={isButtonDisabled}
                        >
                          {isloading ? "Subiri" : "Hifadhi na Endelea |"}{" "}
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default Step_six;
